let cartTokenURL = 'https://order.lotte-dutyfree.com.au/save-cart-token-jscript.php';

/*fetch('https://ipinfo.io/json', {
    method: 'GET',
    headers: {
        'Accept': 'application/json',
    }
}).then(response => response.json())
.then(function (response) {
	const ipData = response;
	const userIp = ipData.ip;
	setCookie('user_ip', userIp, 1);
});*/

function getCookie(cname) {
  var name = cname + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

/*let userIpAddress = getCookie('user_ip');*/
let cartToken = getCookie('cart');

document.addEventListener('ON_CART_UPDATED', function(e) {
	let cartFormData = new FormData();
	var cartToken = e.detail.cart.token;
	cartFormData.append("carttoken", cartToken);
	/*if( userIpAddress != '' ) {
		cartFormData.append("user_ip", userIpAddress);
	}*/
	saveCartData(cartTokenURL, cartFormData);
});

let cartFormData = new FormData();
if( cartToken != '' ) {
	cartFormData.append("carttoken", cartToken);
	/*if( userIpAddress != '' ) {
		cartFormData.append("user_ip", userIpAddress);
	}*/
	saveCartData(cartTokenURL, cartFormData);
}

function saveCartData(url, cartData) {
	fetch(url, { 
		method: 'POST',
		body: cartData
	}).then(response => console.log('success'));
}